import { Navigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@shared/config/routes';
import { VerifyForm, type OtpChannel } from '@features/auth';
import { AuthLayout } from '@widgets/auth-layout';

export function VerifyPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const identity = params.get('identity');
  const channelParam = params.get('channel');
  if (!identity) return <Navigate to={ROUTES.register} replace />;
  // MVP §2.6: SMS отключён — даже если URL содержит channel=SMS, форсируем EMAIL.
  void channelParam;
  const channel: OtpChannel = 'EMAIL';

  return (
    <AuthLayout title={t('auth.verify.title')} subtitle={t('auth.verify.subtitle', { identity })}>
      <VerifyForm identity={identity} channel={channel} />
    </AuthLayout>
  );
}
